'use strict';

/* Remove .no-js from html if JavaScript is enabled */
document.getElementsByTagName('html')[0].className = document.getElementsByTagName('html')[0].className.replace('no-js', "") + " js";

jQuery(document).ready(function ($) {

    /* Validation
    ---------------------------------------- */
    $('#form-contact').validate();

    /* Placeholder fix
    ---------------------------------------- */
    $('input, textarea').placeholder();

    /* Cookie Info
    ---------------------------------------- */
    if (Cookies.get('cookiesAcknowledged') != 'true') {
        $('#cookie-info').fadeTo(500, 1);
    }

    $('#cookie-info #cookie-close').click(function () {
        $('#cookie-info').fadeOut(500);
        Cookies.set('cookiesAcknowledged', true, { expires: 168, path: '/' });
    });

    //when the slick slide initializes we want to set all of our slides to the same height
    $('.hero-slider-wrapper').on('setPosition', function () {
        eosResizeSlider();
    });

    //we need to maintain a set height when a resize event occurs.
    //Some events will through a resize trigger: $(window).trigger('resize');
    $(window).on('resize', function (e) {
        eosResizeSlider();
    });

    //since multiple events can trigger a slider adjustment, we will control that adjustment here
    function eosResizeSlider() {
        $slickSlider = $('.hero-slider-wrapper');
        $slickSlider.find('.hero-slider-slide').height('auto');

        var slickTrack = $slickSlider.find('.slick-track');
        var slickTrackHeight = $(slickTrack).height();

        $slickSlider.find('.hero-slider-slide').css('height', slickTrackHeight + 'px');
    }

    $('#nav-trigger').on('click', function () {
        if ($(window).width() < 960) {
            $(this).toggleClass('is-active');
            $('.nav-primary-container').toggleClass('is-active');
            $('.nav-primary-container').animate({ scrollTop: 0 });
        }
    });

    $('#hero-scroll').on('click', function () {
        $('html, body').animate({
            scrollTop: $('#hero').outerHeight()
        }, 500);
    });

    $('.video-trigger').on('click', function () {
        var iframe = $(this).data('video');

        if ($('#video-embed').hasClass('active')) {
            $('#video-embed').removeClass('active');

            setTimeout(function () {
                $('#video-embed .container .responsive').html('');
            }, 300);
        } else {
            $('#video-embed .container .responsive').html(iframe);
            $('#video-embed').addClass('active');
        }
    });

    $(window).on("load, resize", function () {
        var viewportWidth = $(window).width();
        if (viewportWidth > 960) {
            $('#nav-trigger').removeClass('is-active');
            $('.nav-primary-container').removeClass('is-active');
            $('.menu-primary li .sub-menu').css({ 'display': '' });
        }
    });

    $(".hamburger").click(function () {

        if ($(this).hasClass('open')) {
            //close
            $(this).removeClass("open");
            $('#mobile').removeClass("open");
            $('html, body').css('overflow-y', '');
        } else {
            //open
            $("html, body").animate({ scrollTop: 0 }, 300);
            $(this).addClass("open");
            $('#mobile').addClass("open");

            setTimeout(function () {
                $('html, body').css('overflow-y', 'hidden');
            }, 300);
        }
    });

    /* FAQs
    ---------------------------------------- */
    $('.faq__title').click(function () {

        //Hide the other panels
        $(".faq__answer").not($(this).parent('.faq').toggleClass('active').find('.faq__answer').slideToggle()).slideUp().parent('.faq').removeClass('active');
    });

    $(document).ready(function () {
        $(".mobile-nav-wrap .menu-primary a").on("click touchend", function (e) {
            var el = $(this);
            var link = el.attr("href");
            window.location = link;
        });
    });
});